/**
 * Locales suportados — 1:1 com o ENUM `locale_code` do banco (`specs.md` §4.4).
 *
 * `pt-BR` foi removido em 2026-08-27 (ADR 0014): o ENUM tinha 5 valores e existiam 4 bundles,
 * ou seja, um valor que o banco aceitava e a aplicação não sabia renderizar. Ao alterar esta
 * lista, alterar o ENUM na mesma migration — a paridade é o que impede o buraco voltar.
 */
export const SUPPORTED_LOCALES = ['pt-PT', 'en', 'es', 'fr'] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const FALLBACK_LOCALE: SupportedLocale = 'pt-PT';

/**
 * Normaliza o locale do dispositivo para um dos 4 suportados.
 *
 * `pt-BR` resolve para `pt-PT`: a variante brasileira saiu do MVP, mas um dispositivo
 * configurado em pt-BR continua existindo e deve ver português — não o fallback por acidente.
 * A regra é explícita para sobreviver a uma futura mudança do fallback.
 */
export function resolveLocale(raw: string | undefined | null): SupportedLocale {
  if (!raw) return FALLBACK_LOCALE;

  const lower = raw.toLowerCase();
  if (lower.startsWith('pt')) return 'pt-PT';

  const base = lower.split('-')[0];
  return (SUPPORTED_LOCALES as readonly string[]).includes(base ?? '')
    ? (base as SupportedLocale)
    : FALLBACK_LOCALE;
}

/** Type guard para validar valor vindo de fora (query string, storage, API). */
export function isSupportedLocale(value: unknown): value is SupportedLocale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
